import React, { useEffect, useState } from "react";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { Link } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Tooltip, OverlayTrigger } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import {
  delete_Record,
  ActiveInactive_Record,
  errorMessage,
} from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import {
  POST_GetCourierDDLList,
  POST_GetCustomerDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetMaterialDispatchList,
  POST_GetMaterialDispatchPrintLabel,
  POST_MaterialDispatchActiveInActive,
  POST_MaterialDispatchDelete,
  POST_MaterialDispatchPrint,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const MaterialDispatch = () => {
  const { filter, updateFilter } = useFilter();

  const [showFilter, setShowFilter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "material-dispatch" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "material-dispatch" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "material-dispatch" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "material-dispatch" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [customerOptions, setCustomerList] = useState([]);
  const [courierOptions, setCourierList] = useState([]);
  const [materialDispatchList, setMaterialDispatchList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      FromDate:
        filter && filter?.page == "material-dispatch"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "material-dispatch"
          ? filter?.ToDate
          : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "material-dispatch"
          ? filter?.CustomerIDEncrypted
          : "",
      MaterialDispatchNo:
        filter && filter?.page == "material-dispatch"
          ? filter?.MaterialDispatchNo
          : "",
      TCNo: filter && filter?.page == "material-dispatch" ? filter?.TCNo : "",
      InwardNo:
        filter && filter?.page == "material-dispatch" ? filter?.InwardNo : "",
      DeliveredTo:
        filter && filter?.page == "material-dispatch"
          ? filter?.DeliveredTo
          : "",
      CourierIDEncrypted:
        filter && filter?.page == "material-dispatch"
          ? filter?.CourierIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "material-dispatch"
          ? filter?.CustomerName
          : "",
      HTMLContentsPrintLabel: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      MaterialDispatchNo,
      TCNo,
      InwardNo,
      DeliveredTo,
      CourierIDEncrypted,
      CustomerName,
      HTMLContentsPrintLabel,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      MaterialDispatchNo: "",
      TCNo: "",
      InwardNo: "",
      DeliveredTo: "",
      CourierIDEncrypted: "",
      CustomerName: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    getCustomerDDL();
    getCourierDDL();
  }, []);

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: -1, // -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerList(
            response?.CustomerDDLList?.map((item) => ({
              label: item.CustomerName,
              value: item.CustomerIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCourierDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCourierDDLList, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCourierList(
            response?.List?.map((item) => ({
              label: item.CourierName,
              value: item.CourierIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "material-dispatch",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      MaterialDispatchNo: MaterialDispatchNo,
      TCNo: TCNo,
      InwardNo: InwardNo,
      DeliveredTo: DeliveredTo,
      CourierIDEncrypted: CourierIDEncrypted,
      CustomerName: CustomerName,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      TCNo: TCNo,
      InwardNo: InwardNo,
      CustomerIDEncrypted: CustomerIDEncrypted,
      MaterialDispatchNo: MaterialDispatchNo,
      DeliveredTo: DeliveredTo,
      CourierIDEncrypted: CourierIDEncrypted,
      MaterialDispatchDateFrom: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      MaterialDispatchDateTo: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    };
    await post(POST_GetMaterialDispatchList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setMaterialDispatchList(response?.List);

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getMaterialDispatchPrint = async (id) => {
    setIsLoading(true);
    let payload = {
      MaterialDispatchIDEncrypt: id,
    };
    post(POST_MaterialDispatchPrint, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMaterialDispatchPrintLabel = async (id) => {
    setIsLoading(true);
    let payload = {
      MaterialDispatchIDEncrypt: id,
    };
    post(POST_GetMaterialDispatchPrintLabel, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          formikFilter.setFieldValue(
            "HTMLContentsPrintLabel",
            response?.HTMLContents
          );
          setTimeout(() => {
            const iframe = document.getElementById("iFrames");
            if (iframe) {
              iframe.contentWindow.print();
            }
            setIsLoading(false);
          }, 500);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Material Dispatch</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "} Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i>Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.Permissions?.DispatchMaterial == 1 &&
                  (AuthUser?.UserType !== 1 ||
                    formsList?.filter((x) => x?.FormID == 36 && x?.IsAdd)
                      ?.length > 0) ? (
                    <Link
                      to={`/add-material-dispatch/${window.btoa(
                        "0"
                      )}/${window.btoa("0")}`}
                      // className="btn btn-primary btn-sm"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Material Dispatch
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <label> Dispatch Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Dispatch No"
                              name="MaterialDispatchNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"TC No..."}
                              component={CustomInput}
                            />
                          </Col>
                        </Row>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCutomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          {/* <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              options={customerOptions}
                              component={CustomSelect}
                              //isClearable={false}
                            />
                          </Col> */}
                          <Col lg={3}>
                            <Field
                              label="Delivered To"
                              name="DeliveredTo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Courier"
                              name="CourierIDEncrypted"
                              placeholder={"Select Courier"}
                              options={courierOptions}
                              component={CustomSelect}
                              //isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="MaterialDispatch-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="MaterialDispatch-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="8%"></th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("MaterialDispatchNo");
                          }}
                        >
                          Dispatch No{" "}
                          <span className="ml-1">
                            {sortBy == "MaterialDispatchNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("MaterialDispatchDate");
                          }}
                        >
                          Dispatch Date{" "}
                          <span className="ml-1">
                            {sortBy == "MaterialDispatchDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>

                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>

                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("DeliveredTo");
                          }}
                        >
                          Delivered To{" "}
                          <span className="ml-1">
                            {sortBy == "DeliveredTo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("DeliveredBy");
                          }}
                        >
                          Delivered By{" "}
                          <span className="ml-1">
                            {sortBy == "DeliveredBy" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>

                        <th
                          style={{
                            width: "13%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("Courier");
                          }}
                        >
                          Courier{" "}
                          <span className="ml-1">
                            {sortBy == "Courier" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {materialDispatchList?.length > 0 ? (
                        materialDispatchList?.map((item, indx) => (
                          <>
                            <tr key={indx}>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  //whiteSpace: "normal",
                                }}
                                className={
                                  item.TCNos ? "border-bottom-0 pb-0" : ""
                                }
                                rowSpan={item.TCNos ? 2 : 1}
                              >
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 36 && x?.IsEdit
                                )?.length > 0 ? (
                                  <Link
                                    to={
                                      item?.IsHold == true
                                        ? "#"
                                        : `/edit-material-dispatch/${window.btoa(
                                            item.MaterialDispatchIDEncrypt
                                          )}`
                                    }
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {/* {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 36 && x?.IsActive
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className={`icon-box icon-box-md bg-${
                                    //   item.IsActive == true ? "success" : "danger"
                                    // }-light me-1`}
                                    className={`icon-box icon-box-md me-1`}
                                    title={
                                      item.IsActive == true
                                        ? "Active"
                                        : "Inactive"
                                    }
                                    onClick={() => {
                                      ActiveInactive_Record(
                                        item.IsActive,
                                        POST_MaterialDispatchActiveInActive,
                                        {
                                          MaterialDispatchIDEncrypt:
                                            item.MaterialDispatchIDEncrypt,
                                          IsActive: !item.IsActive,
                                          ModifiedByEncrypt:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.MaterialDispatchNo
                                      );
                                    }}
                                  >
                                    <i
                                      className={`fa fa-circle fs-15 ${
                                        item.IsActive == true
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                    ></i>
                                  </Link>
                                ) : (
                                  ""
                                )} */}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 36 && x?.IsDelete
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      if (item?.IsHold == false) {
                                        delete_Record(
                                          POST_MaterialDispatchDelete,
                                          {
                                            MaterialDispatchIDEncrypt:
                                              item.MaterialDispatchIDEncrypt,
                                            ModifiedByEncrypt:
                                              AuthUser?.ReferenceIDEncrypt
                                                ? AuthUser?.ReferenceIDEncrypt
                                                : "0",
                                          },
                                          setIsLoading,
                                          fnCallback,
                                          item.MaterialDispatchNo
                                        );
                                      }
                                    }}
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                  className="icon-box icon-box-md me-1"
                                  title="Print"
                                  onClick={(e) => {
                                    if (item?.IsHold == false) {
                                      getMaterialDispatchPrint(
                                        item.MaterialDispatchIDEncrypt
                                      );
                                    }
                                  }}
                                  disabled={item?.IsHold}
                                >
                                  {SVGICON.Printer}
                                </Link>
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                  className="icon-box icon-box-md me-1"
                                  title="Print Label"
                                  onClick={(e) => {
                                    if (item?.IsHold == false) {
                                      getMaterialDispatchPrintLabel(
                                        item.MaterialDispatchIDEncrypt
                                      );
                                    }
                                  }}
                                  disabled={item?.IsHold}
                                >
                                  <i
                                    className="fa fa-print"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.MaterialDispatchNo}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.MaterialDispatchDate}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.CustomerName}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.InwardNo}
                              </td>

                              {/* <td
                                style={{
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                                className={
                                  item.TCNos ? "border-bottom-0 pb-0" : ""
                                }
                              >
                                {item.ProjectName}
                                {"-"}
                                {item.ReportingTo}
                                {item.DeliveredTo ? "-" : ""}
                                {item.DeliveredTo}
                              </td> */}
                              <td
                                style={{
                                  cursor: "pointer",
                                  textAlign: "left",
                                  verticalAlign: "top",
                                }}
                                // className="popupOverlay border-bottom-0 pb-0"
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.ProjectName}
                                        {" - "}
                                        {item.ReportingTo}
                                        {item.DeliveredTo ? " - " : ""}
                                        {item.DeliveredTo}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    {item.ProjectName}
                                    {" - "}
                                    {item.ReportingTo}
                                    {item.DeliveredTo ? " - " : ""}
                                    {item.DeliveredTo}
                                  </span>
                                </OverlayTrigger>
                              </td>

                              <td
                                style={{
                                  whiteSpace: "normal",
                                  // verticalAlign: "top",
                                }}
                                // className={
                                //   item.TCNos ? "border-bottom-0 pb-0" : ""
                                // }
                              >
                                {item.DeliveredBy}
                              </td>
                              {/* <td
                                style={{
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                  textAlign: "left",
                                }}
                                className={
                                  item.TCNos ? "border-bottom-0 pb-0" : ""
                                }
                              >
                                {item.CourierName}
                              </td> */}

                              <td
                                style={{
                                  cursor: "pointer",
                                  textAlign: "left",
                                  // verticalAlign: "top",
                                }}
                                // className="popupOverlay border-bottom-0 pb-0"
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.CourierName}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.CourierName}</span>
                                </OverlayTrigger>
                              </td>
                            </tr>
                            {item.TCNos ? (
                              <tr key={`${indx}.1`}>
                                {/* <td></td> */}
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                    // verticalAlign: "top",
                                  }}
                                  // className="p-0"
                                >
                                  {/* <table className="table dataTable no-footer mb-0">
                                    <tbody>
                                      <tr>
                                        <td
                                          style={{
                                            whiteSpace: "normal",
                                            verticalAlign: "top",
                                          }}
                                          className="border-bottom-0 pt-1 pb-0"
                                        > */}
                                  <div className="d-flex">
                                    <label
                                      className="text-secondary mb-1"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "45px",
                                      }}
                                    >
                                      TC No : &nbsp;
                                    </label>
                                    <div style={{ textAlign: "left" }}>
                                      {item.TCNos}
                                    </div>
                                  </div>
                                  {/* </td>
                                      </tr>
                                    </tbody>
                                  </table> */}
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <hr className="mt-0 mb-1"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: "none" }}>
              <iframe
                id="iFrames"
                title="Print Label"
                width="100%"
                style={{ height: "100vh", display: "none" }}
                frameBorder="0"
                srcDoc={HTMLContentsPrintLabel}
              ></iframe>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default MaterialDispatch;
